import { z } from 'zod';

// Base user event schema
const baseUserEventDataSchema = z.object({
  type: z.string(),
  timestamp: z.number(),
  data: z.record(z.string(), z.unknown()),
});

// NFT Audit specific event data
const nftAuditEventDataSchema = z.object({
  action: z.string(),
  packId: z.string(),
  userId: z.string(),
});

// NFT Audit event
export const nftAuditEventSchema = z.object({
  type: z.literal('NFT_AUDIT'),
  timestamp: z.number(),
  data: nftAuditEventDataSchema,
});

// Pack Delivered specific event data
const packDeliveredEventDataSchema = z.object({
  action: z.literal('PACK_DELIVERED'),
  purchaseId: z.string(),
  packsCount: z.number(),
  packIds: z.array(z.string()),
  userId: z.string(),
});

// Pack Delivered event
export const packDeliveredEventSchema = z.object({
  type: z.literal('PACK_DELIVERED'),
  timestamp: z.number(),
  data: packDeliveredEventDataSchema,
});

// Union of all possible user events
export const userEventSchema = z.discriminatedUnion('type', [nftAuditEventSchema, packDeliveredEventSchema]);

// Fallback to base schema if discriminated union fails
export const userEventOrBaseSchema = z.union([userEventSchema, baseUserEventDataSchema]);

export type NftAuditEvent = z.infer<typeof nftAuditEventSchema>;
export type PackDeliveredEvent = z.infer<typeof packDeliveredEventSchema>;
export type UserEvent = z.infer<typeof userEventSchema>;
export type UserEventOrBase = z.infer<typeof userEventOrBaseSchema>;
